import { http } from "../base"


export async function load_version_settings() {
    try {
        const response = await http.get(
            `/aics/plan/list`
    )
    return response
    } catch (error) {
        return error
    }
}

export async function load_my_fuel_package(tenant_id) {
    try {
        const response = await http.get(
            `/aics/fuel_package/find_by_tenantId?tenant_id=${tenant_id}`
    )
    return response
    } catch (error) {
        return error
    }
}

export async function load_fuel_package() {
    try {
        const response = await http.get(
            `/aics/fuel_package/list`
    )
    return response
    } catch (error) {
        return error
    }
}

     export async function countRemaingMessages(tenantId) {
          console.log("countRemaingMessages",tenantId);
          const response = await http.get(
            `/aics/conversations/count_remaing_messages_by_tenant/${tenantId}`,
          );
          console.log("countRemaingMessages", response);
            // 统一处理响应格式
            if (response==null || response.data?.code !== 200) {
              throw new Error(response.data.message || '获取套餐用了数据失败');
            }
            return response.data;
    }   

         export async function countRemaingMessagesbyVersion(tenantId, versionName) {
          console.log("countRemaingMessagesbyVersion",tenantId, versionName);
          const response = await http.get(
            `/aics/conversations/count_remaing_messages_by_tenant_version?tenant_id=${tenantId}&version_name=${versionName}`,
          );
          console.log("countRemaingMessages", response);
            // 统一处理响应格式
            if (response==null || response.data?.code !== 200) {
              throw new Error(response.data.message || '获取套餐用了数据失败');
            }
            return response.data;
    }  
    
         export async function countConsumedMessagesbyVersion(tenantId, versionName) {
          console.log("countRemaingMessages",tenantId, versionName);
          const response = await http.get(
            `/aics/conversations/count_consumed_messages_by_tenant_version/${tenantId}?version_name=${versionName}`,
          );
          console.log("countRemaingMessages", response);
            // 统一处理响应格式
            if (response==null || response.data?.code !== 200) {
              throw new Error(response.data.message || '获取套餐用了数据失败');
            }
            return response.data;
    }   